import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import spinner from '../assign-prescriptions/images/spinner.gif';
import { withStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import './console.css';
import DEVICE_TYPE from '../enum/device_type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EVENT_TYPES from '../common/event-type';
import LOCATION_TYPE_ID from '../enum/location_type';
import CloseIcon from '@mui/icons-material/Close';
import pendingIcon from '../iLocal-Delivery-Icons/Mail.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import kioskIcon from '../iLocal-Delivery-Icons/Kiosk.svg';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import bedsideIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArrivedNotification from './notificationsound';
import LabelTemplate from '../assign-prescriptions/labelTemplate';
import PrintTemplate from 'react-print';
import { navigate, Link } from '@reach/router';
import { clearStoreLocationOptions } from '../grid/storeLocationFilter';
import io from 'socket.io-client';
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import CollectDeliveryDialog from '../collect-delivery/CollectDeliveryDialog';
import {
  COLLECT_DELIVERY_MESSAGES,
  collectOrderById,
  collectOrderByStock,
  confirmCollectDelivery as submitCollectDelivery,
  fetchDeliveryUsers,
  findUserByBadgeId,
  getCollectDeliveryLocationLabel,
  getDeliveryUserLabel,
  isCollectDeliveryLocationType,
  isOrderInCart,
  lookupDeliveryUserByBadgeId,
  normalizeBadgeId,
} from '../../utils/collectDelivery';
import Box from '@mui/material/Box'
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { withTranslation } from 'react-i18next';
import {
  fetchEntitlements,
  getSelectedBoxId,
  getConsoleTypeFromSearch,
  isConsoleTypeUsable,
  featureKeyForConsoleType,
  getFeatureLockedRedirectPath,
  findEntitlement,
} from '../../utils/productLicensing';
import CustomNotePicker from '../message-control-center/CustomNotePicker';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import PersonIcon from '@mui/icons-material/Person';
import MedicationIcon from '@mui/icons-material/Medication';
import PaymentIcon from '@mui/icons-material/Payment';
import BadgeIcon from '@mui/icons-material/Badge';
import CreateIcon from '@mui/icons-material/Create';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const deliveryType = [
  { id: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500', label: 'Kiosk' },
  { id: '93d79d62-523a-4d4f-851f-6866d38cb340', label: 'Courier' },
  { id: '40a40496-1c2a-4f46-b00a-f210d34f24cd', label: 'Curbside' },
  { id: '7e8e5632-6187-4d9b-9528-adf14825e859', label: 'Bedside' },
  { id: '567c43b9-dd50-4dd0-b293-2f8ebceb035c', label: 'Counter' },
];

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  '@media only screen and (min-width: 1024px) and (max-width:1440px) and (orientation:landscape)': {
    root: {
      width: '75vw',
      minHeight: '50vh',
    },
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  onAmoutDueEditPrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
   '&:hover': {
       background: '#6cca98',
       color: '#fff',
     },
 },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix="$"
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={"."}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class Console extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      page: 0,
      rowsPerPage: 10,
      pendingDelivery: [],
      kioskData: [],
      courierData: [],
      bedSideData: [],
      curbSideData: [],
      counterData: [],
      kioskPage: 0,
      counterPage: 0,
      courierPage: 0,
      bedsidePage: 0,
      curbsidePage: 0,
      searchText: '',
      scanText: '',
      loader: true,
      featureEntitlements: null,
      scanTextError: false,
      popupData: '',
      open_Move: false,
      fromType: '',
      toType: 'Kiosk',
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
      id: '',
      customer_id: '',
      box_id: '',
      pucode: '',
      disableMove: false,
      type_id: '',
      deletepopup: false,
      items: [],
      rowsPerPagePending: 10,
      rowPerPageCounter: 10,
      rowsPerPageCourier: 10,
      rowsPerPageCurbside: 10,
      rowPerPageInPatient: 10,
      rowPerPageInKiosk: 10,
      hasMore: true,
      hasMoreCounter: true,
      hasMoreKiosk: true,
      hasMoreCurbside: true,
      hasMoreCourier: true,
      hasMoreInpatient: true,
      totalCount: [],
      totalCountCounter: [],
      blockInitialNotificationSound: true,
      index: null,
      printDialogOpen: false,
      searchInputRef: null,
      lastSearchText: '',
      collectDeliveryOpen: false,
      collectDeliveryUsers: [],
      collectDeliveryUserId: '',
      collectDeliveryBadge: '',
      collectDeliveryStockCode: '',
      collectDeliveryCart: [],
      collectDeliveryError: '',
      collectDeliveryLoading: false,
      collectDeliveryConfirming: false,
      collectDeliveryLocationTypeId: '',
      customNote: { id: null, text: '', source: '' },
    };
    this.oktaAuthClient = window.oktaAuthClient;
    this.consoleRequest = {
      pageNo: {
        pendingDelivery: 1,
        counter: 1,
        kiosk: 1,
        courier: 1,
        curbside: 1,
        bedside: 1,
      },
      pageSize: {
        pendingDelivery: 10,
        counter: 50,
        kiosk: 10,
        courier: 10,
        curbside: 10,
        bedside: 10,
      },
      scanText: '',
      searchText: '',
      sortColumn: 'created_on',
      sortOrder: 'desc',
      isKaktus: false,
    };
  }

  initSocket = async () => {
    const user = sessionStorage.getItem('user');
    if (!this.socket && user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${
              JSON.parse(user).signInUserSession.idToken.jwtToken
            }`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            this.signOut();
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });

      /**
       ** Socket Console Event Starts **
       */
      this.socket &&
        this.socket.on('console', async (res) => {
          this.setState({
            counterData: [],
            pendingDelivery: [],
            kioskData: [],
            courierData: [],
            curbSideData: [],
            bedSideData: [],
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
          await this.checkNotification(res.curbside, 'totalCount');
          
          // Store search text before state update
          const currentSearchText = this.state.searchText;
          
          this.setState({
            loader: false,
            counterData: res.counter,
            pendingDelivery: res.pendingDelivery,
            kioskData: res.kiosk,
            courierData: res.courier,
            curbSideData: res.curbside,
            bedSideData: res.bedside,
            blockInitialNotificationSound: false,
          }, () => {
            // After state update, check if search text matches a PU code in the fresh data
            if (currentSearchText && currentSearchText.length > 1 && currentSearchText !== this.state.lastSearchText && !this.state.open) {
              // Search in the fresh data that was just set
              const allArrays = [
                { data: res.counter, type: 'counter' },
                { data: res.pendingDelivery, type: 'pending' },
                { data: res.kiosk, type: 'kiosk' },
                { data: res.courier, type: 'courier' },
                { data: res.curbside, type: 'curbside' },
                { data: res.bedside, type: 'bedside' },
              ];

              let matchedOrder = null;
              for (const arrayData of allArrays) {
                if (arrayData.data && arrayData.data.results && arrayData.data.results.length > 0) {
                  const found = arrayData.data.results.find(
                    (order) => order.pucode && order.pucode.toLowerCase() === currentSearchText.toLowerCase().trim()
                  );
                  if (found) {
                    matchedOrder = { ...found, deliveryType: arrayData.type };
                    break;
                  }
                }
              }

              if (matchedOrder) {
                this.setState({ lastSearchText: currentSearchText });
                this.handleOpen(matchedOrder.deliveryType, matchedOrder);
              }
            }
          });
        });

      this.socket &&
        this.socket.on('counter', async (res) => {
          this.setState({
            loader: false,
            counterData: res,
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
        });

      this.socket &&
        this.socket.on('pendingDelivery', (res) => {
          this.setState({
            loader: false,
            pendingDelivery: res,
          });
        });

      this.socket &&
        this.socket.on('kiosk', (res) => {
          this.setState({
            loader: false,
            kioskData: res,
          });
        });

      this.socket &&
        this.socket.on('courier', (res) => {
          this.setState({
            loader: false,
            courierData: res,
          });
        });

      this.socket &&
        this.socket.on('curbside', async (res) => {
          this.setState({
            loader: false,
            curbSideData: res,
          });
          await this.checkNotification(res.curbside, 'totalCount');
        });

      this.socket &&
        this.socket.on('bedside', (res) => {
          this.setState({
            loader: false,
            bedSideData: res,
          });
        });

      this.socket &&
        this.socket.on('changesOnConsole', () => {
          console.log('changesOnConsole event emitted!');
          this.consoleRequest &&
            this.socket &&
            this.socket.emit('getConsole', this.consoleRequest);
        });
    }
  };

  checkNotification = async (res, type) => {
    if (this.state.blockInitialNotificationSound) {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        this.setState({ [type]: arrivedData });
      }
    } else {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        if (arrivedData.length > this.state[type].length) {
          this.setState({ [type]: arrivedData }, () => {
            this.playNotification();
          });
        }
      }
    }
  };

  async componentDidMount() {
    !this.socket && (await this.initSocket());
    console.log(`this.consoleRequest`, this.consoleRequest);
    this.socket &&
      this.socket.emit('getConsole', this.consoleRequest) &&
      this.setState({ loader: true });
    this.loadFeatureEntitlements();
    
    // Focus on search field after component mounts
    setTimeout(() => {
      if (this.searchInputRef) {
        this.searchInputRef.focus();
      }
      this.scrollToConsoleType();
    }, 100);
  }

  componentWillUnmount() {
    this._unmounted = true;
    clearInterval(this.interval);
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  getConsoleTypeFromUrl = () => {
    return getConsoleTypeFromSearch(window.location.search);
  };

  isConsoleSectionUsable = (type) =>
    isConsoleTypeUsable(type, this.state.featureEntitlements);

  redirectLockedConsoleType = () => {
    const type = this.getConsoleTypeFromUrl();
    if (!type || !Array.isArray(this.state.featureEntitlements)) {
      return false;
    }
    if (this.isConsoleSectionUsable(type)) {
      return false;
    }
    const featureKey = featureKeyForConsoleType(type);
    if (featureKey) {
      navigate(getFeatureLockedRedirectPath(featureKey));
      return true;
    }
    return false;
  };

  loadFeatureEntitlements = () => {
    fetchEntitlements({ boxId: getSelectedBoxId() })
      .then((data) => {
        this.setState(
          { featureEntitlements: (data && data.entitlements) || [] },
          () => {
            if (!this.redirectLockedConsoleType()) {
              this.scrollToConsoleType();
            }
          }
        );
      })
      .catch(() => {
        this.setState({ featureEntitlements: [] }, () => {
          if (!this.redirectLockedConsoleType()) {
            this.scrollToConsoleType();
          }
        });
      });
  };

  renderConsoleLicenseCallout = (type) => {
    const { t } = this.props;
    if (this.isConsoleSectionUsable(type) || !Array.isArray(this.state.featureEntitlements)) {
      return null;
    }
    const featureKey = featureKeyForConsoleType(type);
    const entitlement = findEntitlement(this.state.featureEntitlements, featureKey);
    return (
      <div style={{ padding: '8px 12px 0' }}>
        <Link to={getFeatureLockedRedirectPath(featureKey)}>
          {t('Console.FeatureLocked', {
            defaultValue:
              'This queue is not enabled yet. Finish existing orders, then talk to an expert to keep using it.',
          })}
          {entitlement && entitlement.title ? ` (${entitlement.title})` : ''}
        </Link>
      </div>
    );
  };

  scrollToConsoleType = (attempt = 0) => {
    if (this._unmounted) {
      return;
    }
    const type = this.getConsoleTypeFromUrl();
    if (!type) {
      return;
    }
    const node = document.getElementById(`console-section-${type}`);
    if (node) {
      node.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (attempt < 20) {
      setTimeout(() => this.scrollToConsoleType(attempt + 1), 250);
    }
  };

  playNotification = () => {
    // ArrivedNotification.play();
    //e.preventDefault();
    let sound = document.getElementById('curbSound');
    sound.play();
  };

  handleClose = () => {
    this.setState({ 
      open: false, 
      lastSearchText: '',
      searchText: '' 
    }, () => {
      // Clear the search in console request and reset search
      this.consoleRequest.searchText = '';
      this.socket && this.socket.emit('getConsole', this.consoleRequest);
      
      // Clear the search input field
      if (this.searchInputRef) {
        this.searchInputRef.value = '';
      }
      
      // Focus back on search field after closing
      setTimeout(() => {
        if (this.searchInputRef) {
          this.searchInputRef.focus();
        }
      }, 100);
    });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  handleCloseMove = () => {
    this.setState({ open_Move: false });
  };

  handleMoveOpen = () => {
    this.setState({
      open_Move: true,
      disableMove: true,
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
    });
  };

  handleOpen = (type, obj) => {
    const collectLocationTypeId = {
      bedside: LOCATION_TYPE_ID.Bedside,
      curbside: LOCATION_TYPE_ID.Curbside,
      courier: LOCATION_TYPE_ID.Courier,
      counter: LOCATION_TYPE_ID.Counter,
    }[type];

    if (
      this.state.collectDeliveryOpen &&
      isCollectDeliveryLocationType(collectLocationTypeId)
    ) {
      if (
        this.state.collectDeliveryLocationTypeId &&
        collectLocationTypeId !== this.state.collectDeliveryLocationTypeId
      ) {
        this.setState({ collectDeliveryError: COLLECT_DELIVERY_MESSAGES.mixedLocation });
        return;
      }
      this.addCollectDeliveryOrder(obj);
      return;
    }

    this.setState({ type_id: obj.type_id, index: '' });
    if (obj.locationtype_id === LOCATION_TYPE_ID.Kiosk) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Kiosk });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Counter) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Counter });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Courier) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Courier });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Curbside) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Curbside });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Bedside) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Bedside });
    }

    if (type === 'kiosk' || obj.DeliveryType === 'Kiosk') {
      this.setState({ disableMove: true });
    } else {
      this.setState({ disableMove: false });
    }
    this.setState({
      fromType: obj.DeliveryType,
      id: obj.id,
      customer_id: obj.customer_id,
      box_id: obj.box_id,
      pucode: obj.pucode,
      loader: true,
    });
    fetch(
      process.env.REACT_APP_BASEURL +
        `deliveryconsole/getdetailsByID/${obj.id}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        this.setState({ popupData: res }, () => {
          this.setState({ open: true, loader: false });
        });
      });
  };

  findOrderByPUCode = (pucode) => {
    if (!pucode || pucode.length === 0) return null;

    // Search in all delivery type arrays
    const allArrays = [
      { data: this.state.pendingDelivery, type: 'pending' },
      { data: this.state.counterData, type: 'counter' },
      { data: this.state.kioskData, type: 'kiosk' },
      { data: this.state.courierData, type: 'courier' },
      { data: this.state.curbSideData, type: 'curbside' },
      { data: this.state.bedSideData, type: 'bedside' },
    ];

    for (const arrayData of allArrays) {
      if (arrayData.data && arrayData.data.results && arrayData.data.results.length > 0) {
        const found = arrayData.data.results.find(
          (order) => order.pucode && order.pucode.toLowerCase() === pucode.toLowerCase().trim()
        );
        if (found) {
          return { ...found, deliveryType: arrayData.type };
        }
      }
    }
    return null;
  };

  inputHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      if (
        this.state.searchText.length > 1 ||
        this.state.searchText.length === 0
      ) {
        this.consoleRequest.searchText = this.state.searchText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
        
        // Reset last search text when search is cleared
        if (this.state.searchText.length === 0) {
          this.setState({ lastSearchText: '' });
        }
      }
    });
  };

  scanHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      if (
        this.state.scanText.length === 6 ||
        this.state.scanText.length === 0
      ) {
        this.consoleRequest.scanText = this.state.scanText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
      }
      if (this.state.scanText.length > 6) {
        this.setState({ scanTextError: true });
      } else {
        this.setState({ scanTextError: false });
      }
    });
  };

  getAuthToken = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    return (
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken
    );
  };

  openCollectDeliveryDialog = async (locationTypeId) => {
    this.setState({
      collectDeliveryOpen: true,
      collectDeliveryLocationTypeId: locationTypeId,
      collectDeliveryError: '',
      collectDeliveryStockCode: '',
      collectDeliveryBadge: '',
      collectDeliveryCart: [],
    });

    if (this.state.collectDeliveryUsers.length > 0) {
      return;
    }

    try {
      const users = await fetchDeliveryUsers();
      this.setState({ collectDeliveryUsers: users });
    } catch (error) {
      this.setState({
        collectDeliveryError: COLLECT_DELIVERY_MESSAGES.loadUsers,
      });
    }
  };

  closeCollectDeliveryDialog = () => {
    this.setState({
      collectDeliveryOpen: false,
      collectDeliveryError: '',
      collectDeliveryStockCode: '',
      collectDeliveryBadge: '',
      collectDeliveryUserId: '',
      collectDeliveryCart: [],
      collectDeliveryLocationTypeId: '',
      collectDeliveryLoading: false,
      collectDeliveryConfirming: false,
    });
  };

  handleCollectDeliveryUserChange = (event, selectedUser) => {
    this.setState({
      collectDeliveryUserId: selectedUser ? selectedUser.id : '',
      collectDeliveryBadge: selectedUser ? getDeliveryUserLabel(selectedUser) : '',
      collectDeliveryError: '',
    });
  };

  handleCollectDeliveryUserInputChange = (event, inputValue, reason) => {
    const badgeInput = inputValue || '';
    const matchedUser =
      reason === 'input' ? findUserByBadgeId(this.state.collectDeliveryUsers, badgeInput) : null;

    this.setState({
      collectDeliveryBadge: badgeInput,
      collectDeliveryUserId: matchedUser
        ? matchedUser.id
        : reason === 'input'
          ? ''
          : this.state.collectDeliveryUserId,
      collectDeliveryError: '',
    });
  };

  handleCollectDeliveryBadgeScan = async (badgeValue) => {
    const badgeId = normalizeBadgeId(badgeValue);
    if (!badgeId) {
      this.setState({ collectDeliveryError: COLLECT_DELIVERY_MESSAGES.noUser });
      return;
    }

    const localMatch = findUserByBadgeId(this.state.collectDeliveryUsers, badgeId);
    if (localMatch) {
      this.setState({
        collectDeliveryUserId: localMatch.id,
        collectDeliveryBadge: getDeliveryUserLabel(localMatch),
        collectDeliveryError: '',
      });
      return;
    }

    try {
      const result = await lookupDeliveryUserByBadgeId(badgeId);
      if (!result.success || !result.user) {
        this.setState({
          collectDeliveryError: result.message || COLLECT_DELIVERY_MESSAGES.badgeNotFound,
        });
        return;
      }

      this.setState((prevState) => {
        const alreadyListed = (prevState.collectDeliveryUsers || []).some(
          (deliveryUser) => deliveryUser.id === result.user.id
        );
        return {
          collectDeliveryUsers: alreadyListed
            ? prevState.collectDeliveryUsers
            : [...prevState.collectDeliveryUsers, result.user],
          collectDeliveryUserId: result.user.id,
          collectDeliveryBadge: getDeliveryUserLabel(result.user),
          collectDeliveryError: '',
        };
      });
    } catch (error) {
      this.setState({
        collectDeliveryError: COLLECT_DELIVERY_MESSAGES.badgeNotFound,
      });
    }
  };

  handleCollectDeliveryStockCodeChange = (event) => {
    this.setState({
      collectDeliveryStockCode: event.target.value,
      collectDeliveryError: '',
    });
  };

  addCollectDeliveryOrder = async (orderOrStock) => {
    const fromQueue = orderOrStock && typeof orderOrStock === 'object';
    const stockCode = fromQueue ? orderOrStock.stock_code : orderOrStock;

    const locationTypeId = this.state.collectDeliveryLocationTypeId;

    if (fromQueue && isOrderInCart(this.state.collectDeliveryCart, orderOrStock)) {
      this.setState({ collectDeliveryError: COLLECT_DELIVERY_MESSAGES.alreadyInCart });
      return;
    }
    if (!fromQueue && isOrderInCart(this.state.collectDeliveryCart, { stock_code: stockCode })) {
      this.setState({
        collectDeliveryError: COLLECT_DELIVERY_MESSAGES.alreadyInCart,
        collectDeliveryStockCode: '',
      });
      return;
    }

    this.setState({ collectDeliveryLoading: true, collectDeliveryError: '' });

    try {
      const result = fromQueue
        ? orderOrStock.id
          ? await collectOrderById(orderOrStock.id, locationTypeId)
          : await collectOrderByStock(orderOrStock.stock_code, locationTypeId)
        : await collectOrderByStock(stockCode, locationTypeId);

      if (!result.success || !result.order) {
        this.setState({
          collectDeliveryError: result.message || COLLECT_DELIVERY_MESSAGES.notReady,
          collectDeliveryLoading: false,
        });
        return;
      }

      if (isOrderInCart(this.state.collectDeliveryCart, result.order)) {
        this.setState({
          collectDeliveryError: COLLECT_DELIVERY_MESSAGES.alreadyInCart,
          collectDeliveryStockCode: '',
          collectDeliveryLoading: false,
        });
        return;
      }

      this.setState((prevState) => ({
        collectDeliveryCart: [...prevState.collectDeliveryCart, result.order],
        collectDeliveryStockCode: '',
        collectDeliveryLoading: false,
        collectDeliveryError: '',
      }));
    } catch (error) {
      this.setState({
        collectDeliveryError: COLLECT_DELIVERY_MESSAGES.addStock,
        collectDeliveryLoading: false,
      });
    }
  };

  addCollectDeliveryStockCode = (stockCode) => {
    this.addCollectDeliveryOrder(stockCode || this.state.collectDeliveryStockCode);
  };

  removeCollectDeliveryCartOrder = (orderId) => {
    this.setState((prevState) => ({
      collectDeliveryCart: (prevState.collectDeliveryCart || []).filter(
        (order) => order.id !== orderId
      ),
      collectDeliveryError: '',
    }));
  };

  confirmCollectDelivery = async () => {
    const { collectDeliveryUserId, collectDeliveryCart } = this.state;
    this.setState({ collectDeliveryConfirming: true, collectDeliveryError: '' });

    try {
      const result = await submitCollectDelivery({
        userId: collectDeliveryUserId,
        cart: collectDeliveryCart,
        locationTypeId: this.state.collectDeliveryLocationTypeId,
      });

      if (!result.success) {
        this.setState({
          collectDeliveryConfirming: false,
          collectDeliveryError: result.message || COLLECT_DELIVERY_MESSAGES.confirmFailed,
        });
        return;
      }

      if (result.failedOrderIds && result.failedOrderIds.length > 0) {
        this.setState({
          collectDeliveryConfirming: false,
          collectDeliveryCart: collectDeliveryCart.filter((order) =>
            result.failedOrderIds.includes(order.id)
          ),
          collectDeliveryError: COLLECT_DELIVERY_MESSAGES.partialFailed,
        });
        if (this.socket) {
          this.socket.emit('updateConsole');
        }
        return;
      }

      toast.success(
        this.props.t('CollectDelivery.Success', {
          defaultValue: 'Orders moved to Out for Delivery.',
        })
      );
      if (result.emailDetails && result.emailDetails.length > 0) {
        toast.warn(
          this.props.t('CollectDelivery.NotifyFailed', {
            defaultValue: COLLECT_DELIVERY_MESSAGES.notifyFailed,
          })
        );
      }
      this.setState(
        {
          collectDeliveryOpen: false,
          collectDeliveryCart: [],
          collectDeliveryStockCode: '',
          collectDeliveryBadge: '',
          collectDeliveryUserId: '',
          collectDeliveryLocationTypeId: '',
          collectDeliveryConfirming: false,
          collectDeliveryError: '',
        },
        () => this.socket && this.socket.emit('updateConsole')
      );
    } catch (error) {
      this.setState({
        collectDeliveryConfirming: false,
        collectDeliveryError: COLLECT_DELIVERY_MESSAGES.confirmFailed,
      });
    }
  };

  onChangeDeliveyType = (event) => {
    this.setState({ selectedTypeId: event.target.value }, () => {
      let label = deliveryType.filter((val) => {
        if (val.id === this.state.selectedTypeId) {
          return val.label;
        }
        return '';
      });
      this.setState({ toType: label });
      if (
        this.state.selectedTypeId === 'a5bd2ad0-0780-42cd-a270-7e76c4f20500'
      ) {
        this.setState({ disableMove: true });
      } else {
        this.setState({ disableMove: false });
      }
    });
  };

  moveHandler = (type) => {
    this.setState({ loader: true, open_Move: false, open: false });
    let object_id = '';
    let event_type_name = '';
    let type_id = '';
    if (type === 'move') {
      object_id = DEVICE_TYPE.Move;
      event_type_name = EVENT_TYPES.MOVE;
      type_id = this.state.type_id;
    } else if (type === 'deliver') {
      object_id = DEVICE_TYPE.Out_for_Delivery;
      event_type_name = EVENT_TYPES.Out_for_Delivery;
      type_id = object_id;
    } else if (type === 'complete') {
      object_id = DEVICE_TYPE.Completed;
      event_type_name = EVENT_TYPES.COMPLETE;
      type_id = object_id;
    } else if (type === 'return') {
      object_id = DEVICE_TYPE.Returned;
      event_type_name = EVENT_TYPES.RETURN;
      type_id = object_id;
    } else if (type === 'cancel') {
      object_id = DEVICE_TYPE.Cancelled;
      event_type_name = EVENT_TYPES.CANCEL;
      type_id = object_id;
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    let token =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;
    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: event_type_name,
      description: `Prescription is moved from ${this.state.fromType} to ${this.state.toType} with pickup code ${this.state.pucode}`,
      object_id: object_id,
      tofor_id: this.state.id,
      box_id: this.state.box_id,
      authorization: token,
      customer_id: this.state.customer_id,
      location_type_id: this.state.selectedTypeId,
      type_id: type_id,
      pickup_date:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.pickup_date
          : new Date(),
      order_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.id
          : '',
      account_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.parent_account_id
          : '',
      location_notes:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.present_location
          : '',
      custom_note_id: this.state.customNote && this.state.customNote.id,
      custom_note_text: this.state.customNote && this.state.customNote.text,
      custom_note_source: this.state.customNote && this.state.customNote.source,
    };
    fetch(process.env.REACT_APP_BASEURL + `deliveryconsole/updatestatus`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event_params),
    })
      .then((response) => response.json())
      .then((res) =>
        this.setState(
          { loader: false },
          () => this.socket && this.socket.emit('updateConsole')
        )
      );
  };

  handleCloseCancel = () => {
    this.setState({ deletepopup: false });
  };

  cancelHandler = () => {
    this.setState({ deletepopup: true });
  };

  cancelHandlerOrder = () => {
    this.setState({ deletepopup: false, open: false });
    this.moveHandler('cancel');
  };

  fetchMoreData = (type) => {
    if (type === 'pending') {
      let total = 0;
      total =
        this.state &&
        this.state.pendingDelivery &&
        this.state.pendingDelivery.results &&
        this.state.pendingDelivery.results.length;
      if (
        total > 0 &&
        this.state.pendingDelivery.results.length <
          this.state.pendingDelivery.total
      ) {
        this.setState({ total: this.state.total + total });
        this.setState(
          { rowsPerPagePending: this.state.rowsPerPagePending + 10 },
          () => {
            this.consoleRequest.pageSize.pendingDelivery = this.state.rowsPerPagePending;
            this.socket &&
              this.socket.emit('getPendingDelivery', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMore: false });
      }
    } else if (type === 'counter') {
      let total = 0;
      total =
        this.state &&
        this.state.counterData &&
        this.state.counterData.results &&
        this.state.counterData.results.length;
      if (
        total > 0 &&
        this.state.counterData.results.length < this.state.counterData.total
      ) {
        this.setState(
          { rowPerPageCounter: this.state.rowPerPageCounter + 10 },
          () => {
            this.consoleRequest.pageSize.counter = this.state.rowPerPageCounter;
            this.socket && this.socket.emit('getCounter', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCounter: false });
      }
    } else if (type === 'kiosk') {
      let total = 0;
      total =
        this.state &&
        this.state.kioskData &&
        this.state.kioskData.results &&
        this.state.kioskData.results.length;
      if (
        total > 0 &&
        this.state.kioskData.results.length < this.state.kioskData.total
      ) {
        this.setState(
          { rowPerPageInKiosk: this.state.rowPerPageInKiosk + 10 },
          () => {
            this.consoleRequest.pageSize.kiosk = this.state.rowPerPageInKiosk;
            this.socket && this.socket.emit('getKiosk', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreKiosk: false });
      }
    } else if (type === 'curbside') {
      let total = 0;
      total =
        this.state &&
        this.state.curbSideData &&
        this.state.curbSideData.results &&
        this.state.curbSideData.results.length;
      if (
        total > 0 &&
        this.state.curbSideData.results.length < this.state.curbSideData.total
      ) {
        this.setState(
          { rowsPerPageCurbside: this.state.rowsPerPageCurbside + 10 },
          () => {
            this.consoleRequest.pageSize.curbside = this.state.rowsPerPageCurbside;
            this.socket && this.socket.emit('getCurbside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCurbside: false });
      }
    } else if (type === 'courier') {
      let total = 0;
      total =
        this.state &&
        this.state.courierData &&
        this.state.courierData.results &&
        this.state.courierData.results.length;
      if (
        total > 0 &&
        this.state.courierData.results.length < this.state.courierData.total
      ) {
        this.setState(
          { rowsPerPageCourier: this.state.rowsPerPageCourier + 10 },
          () => {
            this.consoleRequest.pageSize.courier = this.state.rowsPerPageCourier;
            this.socket && this.socket.emit('getCourier', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCourier: false });
      }
    } else if (type === 'inpatient') {
      let total = 0;
      total =
        this.state &&
        this.state.bedSideData &&
        this.state.bedSideData.results &&
        this.state.bedSideData.results.length;
      if (
        total > 0 &&
        this.state.bedSideData.results.length < this.state.bedSideData.total
      ) {
        this.setState(
          { rowPerPageInPatient: this.state.rowPerPageInPatient + 10 },
          () => {
            this.consoleRequest.pageSize.bedside = this.state.rowPerPageInPatient;
            this.socket && this.socket.emit('getBedside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreInpatient: false });
      }
    }
  };

  printTemplete = async () => {
    this.setState({ open: false, printDialogOpen: true });
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false });
    }, 500);
  };

  reminderHandler = () => {
    this.setState({ open: false, loader: true });
    let data = {
      order_id: this.state.popupData.id,
      account_id: this.state.popupData.parent_account_id,
      location_type_id: this.state.popupData.locationtype_id,
    };

    fetch(process.env.REACT_APP_BASEURL + 'delivery/remindnotification', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) =>
        this.setState(
          { loader: false },
          () => this.socket && this.socket.emit('updateConsole')
        )
      )
      .catch((error) => {
        console.log('error', error);
        this.setState({ loader: false });
      });
  };

  signOut = () => {
    this.socket && this.socket.disconnect();
    if (this.oktaAuthClient) {
      this.oktaAuthClient.signOut({
        postLogoutRedirectUri: `${window.location.origin}/`,
      });
    } else {
      navigate(`/`);
    }

    console.log('Signing Out ✌🏻');
    clearInterval(window.otherUsersInterval);
    sessionStorage.setItem('user', JSON.stringify({}));
    sessionStorage.setItem('permissions', JSON.stringify([]));
    sessionStorage.removeItem('roleId');
    clearStoreLocationOptions();
    this.socket = false;
  };

  getOrdersDueAmount = () => {
    const { popupData } = this.state;
    let amount = 0;
    if(popupData && popupData.items && popupData.items.length > 0){
      for (let i = 0; i < popupData.items.length; i++) {
          if(!isNaN(parseFloat(popupData.items[i].price))){
            let due = parseFloat(popupData.items[i].price);
            amount = amount + due;
          }
      }
    }
    return `$${amount.toFixed(2)}`;
  }

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ index });
  };

  handleChangeDueAmount = (id, type ,value) => {
    if(type === 'price'){
      this.setState(prevState => ({
          popupData: {
            ...prevState.popupData,
            items: [
              ...prevState.popupData.items.map((item) => {
              if(item.id === id){
                return { ...item, price: parseFloat(value)}
              }
              return item;
             })
            ]
          }
      }))
    }
  };

  handleUpdateDueAmount = (index, id) => {
    this.setState({ index: Math.random() || index, open: false });
    const { popupData } = this.state;
    const items = popupData && popupData.items && popupData.items.length && popupData.items.find(x => x.id === id);
    this.updateOrderDueAmount(id, items['price']);
  };

  updateOrderDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    }
    try{
      fetch(process.env.REACT_APP_BASEURL + "updateorderdueamout", {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession
              .idToken.jwtToken,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(updateParams)
      })
      .then((response) => {
        try{
          return response.json()
        }catch(error){
          return null;
        }
      })
      .then((res) => {
        this.setState({ loader: false });
        if(res){
          toast.success(res && res.UpdateDueAmount && res.UpdateDueAmount.message);
        }else{
          toast.error(res.error);
        }
     })
    }catch(error){
      this.setState({ loader: false });
      console.log(error);
    }
  }

  RenderAmountLayout = () => {
    const { popupData } = this.state;
    const { t } = this.props;
    const style = {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '0.75rem',
      fontWeight: 500,
      textAlign: 'right',
      borderBottom: 'none',
      padding: '4px 25px 4px 24px !important',
      width: '91%',
    };
    return (
      <div>
        <Table aria-labelledby='tableTitle'>
        <TableRow style={{ height: 40 }}>
            <TableCell style={style}>{t("Console.ActionPopup.AmountTotal")}</TableCell>
            <TableCell style={{ textAlign: 'left' }}>
             {this.getOrdersDueAmount()}
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
            <TableCell style={style}>{t("Console.ActionPopup.AmountDue")}</TableCell>
            <TableCell style={{ textAlign: 'left', padding: '0px !important' }}>
            {popupData && popupData.amount && popupData.amount.isPaid === false
              ? this.getOrdersDueAmount()
              : `$${(0).toFixed(2)}`
             }
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
            <TableCell style={style}>{t("Console.ActionPopup.Paid")}</TableCell>
            <TableCell style={{ textAlign: 'left' }}>
              {popupData && popupData.amount && popupData.amount.isPaid === true
                ? this.getOrdersDueAmount()
                : `$${(0).toFixed(2)}`
              }
            </TableCell>
          </TableRow>
        </Table>
      </div>
    );
  };

  compare = (a, b) => {
    let comparison = 0;
    if(a.type_id === DEVICE_TYPE.Arrived && a.is_paid === true){
      const typeIdA = a && a.type_id.toUpperCase();
      const typeIdB = b && b.type_id.toUpperCase();
      if (typeIdA > typeIdB) {
        comparison = -1;
      } else if (typeIdA < typeIdB) {
        comparison = 1;
      }
    }
    if(a.is_paid === true){
      const typeIdA = a && a.is_paid;
      const typeIdB = b && b.is_paid;
      if (typeIdA > typeIdB){
        comparison = -1;
      } else if (typeIdA < typeIdB){
        comparison = 1;
      }
    }
    // if(a.type_id === DEVICE_TYPE.Arrived){
    //   const typeIdA = a && a.type_id.toUpperCase();
    //   const typeIdB = b && b.type_id.toUpperCase();
    //   if (typeIdA > typeIdB){
    //     comparison = -1;
    //   } else if(typeIdA < typeIdB){
    //     comparison = 1;
    //   }
    // }
    return comparison;
  }

  getPatientMRN = (value) => {
    if(value !== '' && value !== 'null' && value !== null && value !== undefined && value !== 'undefined'){
      return value;
    }
    return '';
  }

  // Modern RenderAmountLayout for Counter location type (same as CounterAssignUI)
  RenderAmountLayoutCounter = () => {
    const { t } = this.props;
    const { popupData } = this.state;
    const isPaid = popupData && popupData.amount && popupData.amount.isPaid === true;
    const totalAmount = this.getOrdersDueAmount();
    const paymentStatusColor = isPaid ? "#10b981" : "#ef4444";
    const paymentStatusText = isPaid ? t("Console.ActionPopup.Paid") : t("Console.ActionPopup.AmountDue");
    const paymentStatusIcon = isPaid ? <CheckCircleIcon /> : <CancelIcon />;

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          p: 2.5,
          backgroundColor: isPaid ? "#f0fdf4" : "#fef2f2",
          borderRadius: 2,
          border: `2px solid ${paymentStatusColor}`,
          boxShadow: `0 2px 8px ${paymentStatusColor}20`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Chip
            icon={paymentStatusIcon}
            label={paymentStatusText}
            sx={{
              backgroundColor: isPaid ? "#d1fae5" : "#fee2e2",
              color: paymentStatusColor,
              fontWeight: 700,
              fontSize: "0.875rem",
              px: 2,
              py: 1,
              height: "auto",
              "& .MuiChip-icon": {
                color: paymentStatusColor,
                fontSize: "1.25rem",
              },
            }}
          />
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "0.875rem",
              color: "#64748b",
            }}
          >
            {t("Console.ActionPopup.AmountTotal")}:
          </Typography>
        </Box>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "1.75rem",
            color: paymentStatusColor,
            letterSpacing: "-0.02em",
          }}
        >
          {totalAmount}
        </Typography>
      </Box>
    );
  };

  // Modern renderOrderDetailsDialog for Counter location type (same as CounterAssignUI)
  renderOrderDetailsDialog = () => {
    const { t } = this.props;
    const { open, popupData, loader, index, disableMove } = this.state;

    const isPaid = popupData && popupData.amount && popupData.amount.isPaid === true;

    const idCaptureImages =
      (popupData && popupData.capturedImages && Array.isArray(popupData.capturedImages))
        ? popupData.capturedImages.map(item => item.image_url).filter(Boolean)
        : [];

    return (
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={this.handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            pb: 2,
            pt: 3,
            background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
            color: "#ffffff",
            position: "relative",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              letterSpacing: "0.02em",
            }}
          >
            {t("Console.ActionPopup.TakeActionTitle")}
          </Typography>
          <Tooltip title={t("Console.ActionPopup.CancelTooltip")}>
            <IconButton
              aria-label="Cancel"
              onClick={this.handleClose}
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent sx={{ p: 3, backgroundColor: "#f8fafc" }}>
          {loader ? (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <Typography sx={{ color: "#7c3aed", fontSize: "1.1rem" }}>
                Loading...
              </Typography>
            </Box>
          ) : popupData !== "" &&
            popupData !== undefined &&
            popupData !== "undefined" ? (
            <React.Fragment>
              <Grid container spacing={3}>
                {/* Left Column - Patient & Order Information */}
                <Grid item xs={12} md={6}>
                  {/* Patient Information Card */}
                  <Card
                    elevation={0}
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2.5,
                          pb: 2,
                          borderBottom: "2px solid #f1f5f9",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "#7c3aed",
                            mr: 1.5,
                            width: 32,
                            height: 32,
                          }}
                        >
                          <PersonIcon sx={{ fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color: "#1e293b",
                          }}
                        >
                          {t("Console.ActionPopup.PatientInformation")}
                        </Typography>
                      </Box>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.PickupCode")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                            }}
                          >
                            {popupData.pucode || "N/A"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.StockCode")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                            }}
                          >
                            {popupData.stock_code || "N/A"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.PatientName")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontWeight: 600,
                              fontSize: "1rem",
                            }}
                          >
                            {popupData.first_name} {popupData.last_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.PhoneNumber")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontSize: "0.9rem",
                            }}
                          >
                            {popupData.phone || "N/A"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.Email")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontSize: "0.9rem",
                            }}
                          >
                            {popupData.email || "N/A"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#64748b",
                              fontSize: "0.75rem",
                              mb: 0.5,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {t("Console.ActionPopup.StorageLocation")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#1e293b",
                              fontSize: "0.9rem",
                            }}
                          >
                            {popupData.storage_location || "N/A"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  {/* Prescription Items Table */}
                  <Card
                    elevation={0}
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2.5,
                          pb: 2,
                          borderBottom: "2px solid #f1f5f9",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "#7c3aed",
                            mr: 1.5,
                            width: 32,
                            height: 32,
                          }}
                        >
                          <MedicationIcon sx={{ fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color: "#1e293b",
                          }}
                        >
                          Prescription Items
                        </Typography>
                      </Box>
                      <Box sx={{ overflowX: "auto" }}>
                        <Table>
                          <TableHead>
                            <TableRow
                              sx={{
                                backgroundColor: "#f1f5f9",
                                "& .MuiTableCell-head": {
                                  color: "#1e293b",
                                  fontWeight: 700,
                                  fontSize: "0.75rem",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  borderBottom: "2px solid #cbd5e1",
                                },
                              }}
                            >
                              <TableCell>
                                {t("Console.ActionPopup.RxNumber")}
                              </TableCell>
                              <TableCell>
                                {t("Console.ActionPopup.DrugName")}
                              </TableCell>
                              <TableCell>
                                {t("Console.ActionPopup.NDCCode")}
                              </TableCell>
                              <TableCell align="right">
                                {t("Console.ActionPopup.Amount")}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {popupData.items &&
                              popupData.items.length > 0 ? (
                              popupData.items.map((val, idx) => {
                                return (
                                  <TableRow
                                    key={val.id}
                                    sx={{
                                      "&:hover": {
                                        backgroundColor: "#f8fafc",
                                      },
                                      "&:last-child td": {
                                        borderBottom: "none",
                                      },
                                    }}
                                  >
                                    <TableCell
                                      sx={{
                                        color: "#1e293b",
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      {val.rx_no}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "#1e293b",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {val.drug_name}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "#64748b",
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      {val.ndc_code}
                                    </TableCell>
                                    <TableCell align="right">
                                      {index !== idx ? (
                                        <Typography
                                          sx={{
                                            color: "#1e293b",
                                            fontSize: "0.875rem",
                                            fontWeight: 600,
                                          }}
                                        >
                                          ${val.price.toFixed(2)}
                                        </Typography>
                                      ) : (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                            gap: 1,
                                          }}
                                        >
                                          <TextField
                                            size="small"
                                            value={parseFloat(val.price)}
                                            onChange={(e) =>
                                              this.handleChangeDueAmount(
                                                val.id,
                                                "price",
                                                e.target.value
                                              )
                                            }
                                            InputProps={{
                                              inputComponent: NumberFormatCustom,
                                            }}
                                            sx={{
                                              width: "100px",
                                              "& .MuiOutlinedInput-root": {
                                                fontSize: "0.875rem",
                                              },
                                            }}
                                          />
                                          <Tooltip
                                            title={t(
                                              "Console.ActionPopup.SaveTooltip"
                                            )}
                                          >
                                            <IconButton
                                              size="small"
                                              onClick={() =>
                                                this.handleUpdateDueAmount(
                                                  idx,
                                                  val.id
                                                )
                                              }
                                              sx={{
                                                color: "#7c3aed",
                                                "&:hover": {
                                                  backgroundColor: "rgba(124, 58, 237, 0.1)",
                                                },
                                              }}
                                            >
                                              <SaveIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        </Box>
                                      )}
                                      {!isPaid &&
                                        index !== idx &&
                                        popupData.amount &&
                                        popupData.amount.isPaid === false && (
                                          <Tooltip
                                            title={t(
                                              "Console.ActionPopup.EditTooltip"
                                            )}
                                          >
                                            <IconButton
                                              size="small"
                                              onClick={() =>
                                                this.handleOpenDueAmountEditInput(
                                                  idx
                                                )
                                              }
                                              sx={{
                                                ml: 1,
                                                color: "#7c3aed",
                                                "&:hover": {
                                                  backgroundColor: "rgba(124, 58, 237, 0.1)",
                                                },
                                              }}
                                            >
                                              <EditIcon fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={4}
                                  align="center"
                                  sx={{
                                    py: 4,
                                    color: "#94a3b8",
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  No prescription items
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Right Column - Payment, ID Capture, Signature */}
                <Grid item xs={12} md={6}>
                  {/* Payment Information Card */}
                  <Card
                    elevation={0}
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2.5,
                          pb: 2,
                          borderBottom: "2px solid #f1f5f9",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: isPaid ? "#10b981" : "#ef4444",
                            mr: 1.5,
                            width: 32,
                            height: 32,
                          }}
                        >
                          <PaymentIcon sx={{ fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color: "#1e293b",
                          }}
                        >
                          Payment Information
                        </Typography>
                      </Box>
                      {this.RenderAmountLayoutCounter()}
                    </CardContent>
                  </Card>

                  {/* ID Capture Card */}
                  <Card
                    elevation={0}
                    sx={{
                      mb: 3,
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                      height: "320px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2.5,
                          pb: 2,
                          borderBottom: "2px solid #f1f5f9",
                          flexShrink: 0,
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "#7c3aed",
                            mr: 1.5,
                            width: 32,
                            height: 32,
                          }}
                        >
                          <BadgeIcon sx={{ fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color: "#1e293b",
                          }}
                        >
                          {t("Report.Consult.IDCapture") || "ID Capture"}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: 1, overflow: "auto" }}>
                        {idCaptureImages && idCaptureImages.length > 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              gap: 2,
                              flexWrap: "wrap",
                              maxHeight: "240px",
                              overflowY: "auto",
                              "&::-webkit-scrollbar": {
                                width: "8px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f5f9",
                                borderRadius: "4px",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#7c3aed",
                                borderRadius: "4px",
                                "&:hover": {
                                  background: "#6d28d9",
                                },
                              },
                            }}
                          >
                            {idCaptureImages.map((imageUrl, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  flex: "1 1 calc(50% - 8px)",
                                  minWidth: "200px",
                                  border: "2px solid #e2e8f0",
                                  borderRadius: 2,
                                  overflow: "hidden",
                                  p: 1,
                                  backgroundColor: "#f8fafc",
                                  height: "200px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={imageUrl}
                                  alt={`ID Capture ${idx + 1}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                    display: "block",
                                  }}
                                />
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              textAlign: "center",
                              py: 4,
                              backgroundColor: "#f8fafc",
                              borderRadius: 2,
                              border: "2px dashed #cbd5e1",
                            }}
                          >
                            <BadgeIcon
                              sx={{
                                fontSize: 48,
                                color: "#cbd5e1",
                                mb: 1,
                              }}
                            />
                            <Typography
                              sx={{
                                color: "#94a3b8",
                                fontSize: "0.875rem",
                              }}
                            >
                              No ID captured
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </CardContent>
                  </Card>

                  {/* Signature Card */}
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: "1px solid #e2e8f0",
                      background: "#ffffff",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 2.5,
                          pb: 2,
                          borderBottom: "2px solid #f1f5f9",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "#7c3aed",
                            mr: 1.5,
                            width: 32,
                            height: 32,
                          }}
                        >
                          <CreateIcon sx={{ fontSize: 20 }} />
                        </Avatar>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            color: "#1e293b",
                          }}
                        >
                          {t("Console.ActionPopup.Signature") || "Signature"}
                        </Typography>
                      </Box>
                      {popupData.signature_url ? (
                        <Box
                          sx={{
                            border: "2px solid #e2e8f0",
                            borderRadius: 2,
                            overflow: "hidden",
                            p: 2,
                            backgroundColor: "#f8fafc",
                            textAlign: "center",
                          }}
                        >
                          <img
                            src={popupData.signature_url}
                            alt="signature"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200px",
                              objectFit: "contain",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            textAlign: "center",
                            py: 4,
                            backgroundColor: "#f8fafc",
                            borderRadius: 2,
                            border: "2px dashed #cbd5e1",
                          }}
                        >
                          <CreateIcon
                            sx={{
                              fontSize: 48,
                              color: "#cbd5e1",
                              mb: 1,
                            }}
                          />
                          <Typography
                            sx={{
                              color: "#94a3b8",
                              fontSize: "0.875rem",
                            }}
                          >
                            No signature available
                          </Typography>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Action Buttons */}
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1.5,
                  justifyContent: "center",
                  pt: 3,
                  borderTop: "2px solid #e2e8f0",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => this.reminderHandler("deliver")}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    background: "#7c3aed",
                    color: "#ffffff",
                    boxShadow: "0 4px 14px 0 rgba(124, 58, 237, 0.3)",
                    "&:hover": {
                      background: "#6d28d9",
                      boxShadow: "0 6px 20px 0 rgba(124, 58, 237, 0.4)",
                    },
                    "&:disabled": {
                      background: "#b0bec5",
                      color: "#ffffff",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Remind")}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.moveHandler("deliver")}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    background: "#10b981",
                    color: "#ffffff",
                    boxShadow: "0 4px 14px 0 rgba(16, 185, 129, 0.3)",
                    "&:hover": {
                      background: "#059669",
                      boxShadow: "0 6px 20px 0 rgba(16, 185, 129, 0.4)",
                    },
                    "&:disabled": {
                      background: "#b0bec5",
                      color: "#ffffff",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Deliver")}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => this.moveHandler("complete")}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    background: "#10b981",
                    color: "#ffffff",
                    boxShadow: "0 4px 14px 0 rgba(16, 185, 129, 0.3)",
                    "&:hover": {
                      background: "#059669",
                      boxShadow: "0 6px 20px 0 rgba(16, 185, 129, 0.4)",
                    },
                    "&:disabled": {
                      background: "#b0bec5",
                      color: "#ffffff",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Complete")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => this.moveHandler("return")}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    borderColor: "#f59e0b",
                    color: "#f59e0b",
                    borderWidth: 2,
                    "&:hover": {
                      borderColor: "#d97706",
                      backgroundColor: "rgba(245, 158, 11, 0.1)",
                      borderWidth: 2,
                    },
                    "&:disabled": {
                      borderColor: "#b0bec5",
                      color: "#b0bec5",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Return")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => this.handleMoveOpen()}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    borderColor: "#7c3aed",
                    color: "#7c3aed",
                    borderWidth: 2,
                    "&:hover": {
                      borderColor: "#6d28d9",
                      backgroundColor: "rgba(124, 58, 237, 0.1)",
                      borderWidth: 2,
                    },
                    "&:disabled": {
                      borderColor: "#b0bec5",
                      color: "#b0bec5",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Move")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => this.cancelHandler()}
                  disabled={disableMove}
                  sx={{
                    textTransform: "none",
                    minWidth: "120px",
                    minHeight: "43px",
                    borderRadius: 2,
                    fontWeight: 600,
                    borderColor: "#ef4444",
                    color: "#ef4444",
                    borderWidth: 2,
                    "&:hover": {
                      borderColor: "#dc2626",
                      backgroundColor: "rgba(239, 68, 68, 0.1)",
                      borderWidth: 2,
                    },
                    "&:disabled": {
                      borderColor: "#b0bec5",
                      color: "#b0bec5",
                    },
                  }}
                >
                  {t("Console.ActionPopup.Cancel")}
                </Button>
              </Box>
            </React.Fragment>
          ) : null}
        </DialogContent>
      </Dialog>
    );
  };

  renderCollectDeliveryDialog = () => {
    const {
      collectDeliveryOpen,
      collectDeliveryUsers,
      collectDeliveryUserId,
      collectDeliveryBadge,
      collectDeliveryStockCode,
      collectDeliveryCart,
      collectDeliveryError,
      collectDeliveryLoading,
      collectDeliveryConfirming,
      collectDeliveryLocationTypeId,
    } = this.state;

    return (
      <CollectDeliveryDialog
        open={collectDeliveryOpen}
        users={collectDeliveryUsers}
        selectedUserId={collectDeliveryUserId}
        badgeInput={collectDeliveryBadge}
        stockCode={collectDeliveryStockCode}
        cart={collectDeliveryCart}
        error={collectDeliveryError}
        loading={collectDeliveryLoading}
        confirming={collectDeliveryConfirming}
        onClose={this.closeCollectDeliveryDialog}
        onUserChange={this.handleCollectDeliveryUserChange}
        onBadgeInputChange={this.handleCollectDeliveryUserInputChange}
        onBadgeScan={this.handleCollectDeliveryBadgeScan}
        onStockCodeChange={this.handleCollectDeliveryStockCodeChange}
        onAddStock={this.addCollectDeliveryStockCode}
        onRemoveOrder={this.removeCollectDeliveryCartOrder}
        onConfirm={this.confirmCollectDelivery}
        locationLabel={getCollectDeliveryLocationLabel(collectDeliveryLocationTypeId)}
        t={this.props.t}
      />
    );
  };

  renderCollectDeliveryCardButton = (locationTypeId) => {
    const { t } = this.props;
    return (
      <Button
        size="small"
        variant="outlined"
        onClick={() => this.openCollectDeliveryDialog(locationTypeId)}
        sx={{
          minWidth: '132px',
          textTransform: 'none',
          fontWeight: 600,
          borderColor: '#7c3aed',
          color: '#7c3aed',
          borderWidth: 2,
          backgroundColor: 'rgba(124, 58, 237, 0.05)',
          '&:hover': {
            borderWidth: 2,
            borderColor: '#6d28d9',
            backgroundColor: 'rgba(124, 58, 237, 0.1)',
          },
        }}
      >
        {t('CollectDelivery.Title', { defaultValue: 'Collect / Deliver' })}
      </Button>
    );
  };

  render() {
    const { classes, t } = this.props;
    let deletepopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'xs'}
          open={this.state.deletepopup}
          onClose={this.handleCloseCancel}>
          <DialogTitle id='scroll-dialog-title'>
            <span style={{ color: '#423e3e', fontSize: '1.1rem' }}>
             {t("Console.AreYouSureToCancelOrder")}
            </span>
          </DialogTitle>
          <DialogContent
            sx={{ display: 'flex', justifyContent: 'space-between', mt:'2%' }}>
            <Button
              color='primary'
              onClick={() => this.cancelHandlerOrder()}
              className={classes.primaryButton}
              sx={{minWidth: '100px', minHeight:'43px'}}>
              {t("Console.YES")}
            </Button>
            <Button
              color='primary'
              onClick={() => this.handleCloseCancel()}
              className={classes.primaryButton}
              sx={{minWidth: '100px', minHeight:'43px'}}>
              {t("Console.NO")}
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );

    let popup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.state.open}
          onClose={this.handleClose}>
          <DialogTitle id='scroll-dialog-title' sx={{ textAlign: 'center' }}>
            <span className="title">{t("Console.ActionPopup.TakeActionTitle")}</span>
            <Tooltip title={t("Console.ActionPopup.CancelTooltip")}>
              <IconButton aria-label="Cancel" onClick={this.handleClose} style={{marginTop: '-8px', float:'right'}}
                 sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                  <CloseIcon />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent>
            {this.state.popupData !== '' &&
            this.state.popupData !== undefined &&
            this.state.popupData !== 'undefined' ? (
              <Grid container>
                <Grid item xs={3} className='font-style'>
                  {t("Console.ActionPopup.PickupCode")}
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.pucode}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  {t("Console.ActionPopup.PatientName")}
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.first_name +
                      ' ' +
                      this.state.popupData.last_name}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}} >
                  {t("Console.ActionPopup.PhoneNumber")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.phone}
                </Grid>
                <Grid item xs={2} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.Email")}
                </Grid>
                <Grid item xs={4} sx={{mt: '2%' }}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.email}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.StorageLocation")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.storage_location}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.LocationNotes")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.location_notes}
                </Grid>
                <Grid item xs={12} sx={{mt: '2%'}}>
                  <CustomNotePicker
                    t={this.props.t}
                    boxId={this.state.box_id}
                    locationTypeId={this.state.selectedTypeId}
                    value={this.state.customNote}
                    onChange={(customNote) => this.setState({ customNote })}
                  />
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.PatientNotes")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.patient_notes}
                </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.OrderNotes")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.order_notes}
                </Grid>
                  <Grid container>
                    <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                      {t("Console.ActionPopup.PatientOrderNotes")}
                    </Grid>
                    <Grid item xs={3} sx={{mt: '2%'}}>
                      {this.state.popupData.present_location}
                    </Grid>
                    <Grid item xs={2} className='font-style' sx={{mt: '2%'}}>
                      {t("Console.ActionPopup.Signature")}
                    </Grid>
                    <Grid item xs={4} sx={{mt: '2%'}}>
                      {this.state.popupData !== '' &&
                      this.state.popupData !== undefined &&
                      this.state.popupData !== 'undefined' &&
                      this.state.popupData.signature_url ? (
                        <img
                          src={this.state.popupData.signature_url}
                          alt='noimage'
                          style={{ width: '150px' }}
                        />
                      ) : (
                        ''
                      )}
                    </Grid>
                  </Grid>
                <Grid item xs={3} className='font-style' sx={{mt: '2%'}}>
                  {t("Console.ActionPopup.StockCode")}
                </Grid>
                <Grid item xs={3} sx={{mt: '2%'}}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.stock_code}
                </Grid>
                <br />
                <br />
              </Grid>
            ) : (
              ''
            )}
            {/* Captured Images Section */}
            {this.state.popupData !== '' &&
            this.state.popupData !== undefined &&
            this.state.popupData !== 'undefined' &&
            this.state.popupData.capturedImages &&
            this.state.popupData.capturedImages.length > 0 ? (
              <div style={{ marginTop: '3%' }}>
                <Typography variant="h6" style={{ marginBottom: '2%', fontWeight: 'bold' }}>
                  Captured ID Images
                </Typography>
                <Grid container spacing={2}>
                  {this.state.popupData.capturedImages.map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} key={image.id}>
                      <div style={{ 
                        border: '1px solid #ddd', 
                        borderRadius: '8px', 
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        textAlign: 'center',
                        position: 'relative'
                      }}>
                        <div 
                          style={{
                            position: 'relative',
                            width: '100%',
                            height: '200px',
                            borderRadius: '4px',
                            overflow: 'hidden',
                            cursor: 'pointer'
                          }}
                          onClick={() => window.open(image.image_url, '_blank')}
                        >
                          <img
                            src={image.image_url}
                            alt={`Captured ID`}
                            style={{ 
                              width: '100%', 
                              height: '100%', 
                              objectFit: 'cover',
                              borderRadius: '4px',
                              pointerEvents: 'none'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'block';
                            }}
                          />
                          <div style={{ display: 'none', color: '#666', padding: '20px' }}>
                            Image not available
                          </div>
                          {/* Overlay on hover */}
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(25, 118, 210, 0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: 0,
                            transition: 'opacity 0.3s ease',
                            borderRadius: '4px'
                          }}>
                            <div style={{
                              backgroundColor: 'rgba(255, 255, 255, 0.9)',
                              padding: '8px 16px',
                              borderRadius: '20px',
                              fontSize: '12px',
                              fontWeight: 600,
                              color: '#1976d2',
                              border: '1px solid #1976d2'
                            }}>
                              Click to view
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ) : null}
            <Table class='fixed_headers' style={{marginTop:'3%'}}>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell align='left' scope='row'>{t("Console.ActionPopup.RxNumber")}</TableCell>
                  <TableCell align='left' scope='row'>{t("Console.ActionPopup.DrugName")}</TableCell>
                  <TableCell align='left' scope='row'>{t("Console.ActionPopup.NDCCode")}</TableCell>
                  <TableCell align='left' scope='row'>{t("Console.ActionPopup.Amount")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='tbody-pops' >
                {this.state.popupData !== null &&
                this.state.popupData !== '' &&
                this.state.popupData !== undefined &&
                this.state.popupData !== 'undefined'
                  ? this.state.popupData.items &&
                    this.state.popupData.items.length > 0 &&
                    this.state.popupData.items.map((val, index) => {
                      return (
                        <TableRow key={val.id} className='row-height'>
                          <TableCell component='th' scope='row' align='left'>
                            {val.rx_no}
                          </TableCell>
                          <TableCell align='left'>{val.drug_name}</TableCell>
                          <TableCell align='left'>{val.ndc_code}</TableCell>
                          <TableCell align='left'>
                            {this.state.index !== index && '$' + val.price.toFixed(2)}
                            {this.state.popupData.amount.isPaid === false ?
                             this.state.index === index ?
                              <React.Fragment>
                                  <TextField
                                      style = {{ width: '60px' }}
                                      value={parseFloat(val.price)}
                                      onChange={(e) => this.handleChangeDueAmount(val.id, 'price', e.target.value)}
                                      id="price"
                                      InputProps={{
                                          inputComponent: NumberFormatCustom,
                                          autocomplete: 'new-password',
                                          form: {
                                              autocomplete: 'off',
                                          },
                                          }}
                                        variant='standard'
                                      />
                                      <Tooltip title={t("Console.ActionPopup.SaveTooltip")}>
                                      <IconButton
                                       sx={{ ml: '5%' }}
                                       onClick={() => this.handleUpdateDueAmount(index, val.id)}
                                       className={classes.onAmoutDueEditPrimaryButton}>
                                           <SaveIcon />
                                       </IconButton>
                                      </Tooltip>
                               </React.Fragment>
                               :
                                 <Tooltip title={t("Console.ActionPopup.EditTooltip")}>
                                    <IconButton
                                     className={classes.onAmoutDueEditPrimaryButton}
                                     onClick={() => this.handleOpenDueAmountEditInput(index)}
                                     sx={{ ml: '10%' }}>
                                        <EditIcon />
                                    </IconButton>
                                 </Tooltip>
                            : ('')}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : ''}
              </TableBody>
            </Table>
            <br />
            {this.RenderAmountLayout()}
            <div style={{ marginTop: '2%' }}>
              <Grid container style={{ justifyContent: 'space-evenly' }}>
                <Button
                  color='primary'
                  onClick={() => this.printTemplete()}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Print")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.reminderHandler('deliver')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Remind")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('deliver')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Deliver")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('complete')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Complete")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('return')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Return")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.handleMoveOpen()}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Move")}
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.cancelHandler()}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}
                  sx={{minWidth: '100px', minHeight:'43px'}}>
                  {t("Console.ActionPopup.Cancel")}
                </Button>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    let movePopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={this.state.open_Move}
          onClose={this.handleCloseMove}>
          <DialogTitle id='scroll-dialog-title' style={{ textAlign: 'center' }}>
            <span>{t("Console.MovePopup.MoveAction")}</span>
            <Tooltip title={t("Console.MovePopup.CancelTool")}>
              <IconButton aria-label="Cancel"
               onClick={this.handleCloseMove}
               style={{marginTop: '-8px', float:'right'}}
                sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } })}>
                  <CloseIcon />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item xs={3} className='font-style'>
                {t("Console.MovePopup.PickupCode")}
              </Grid>
              <Grid item xs={3}>
                {this.state.popupData !== '' &&
                  this.state.popupData !== undefined &&
                  this.state.popupData !== 'undefined' &&
                  this.state.popupData.pucode}
              </Grid>
              <Grid item xs={3} className='font-style'>
                {t("Console.MovePopup.Name")}
              </Grid>
              <Grid item xs={3}>
                {this.state.popupData !== '' &&
                  this.state.popupData !== undefined &&
                  this.state.popupData !== 'undefined' &&
                  this.state.popupData.first_name +
                    ' ' +
                    this.state.popupData.last_name}
              </Grid>
            </Grid>
            <div className={classes.root}>
              {this.state.loader ? (
                <div className={classes.spinner}>
                  <img
                    className={classes.spinnerImage}
                    src={spinner}
                    alt='loading'
                  />
                </div>
              ) : null}
            </div>
            <br />
            <Table class='fixed_headers'>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell className='remove-padding'>From</TableCell>
                  <TableCell className='remove-padding' align='right'>
                    {t("Console.MovePopup.To")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{height: '55px'}}>
                  <TableCell
                    component='th'
                    scope='row'
                    className='remove-padding'>
                    {this.state.fromType}
                  </TableCell>
                  <TableCell>
                    <FormControl sx={{width: '28ch'}}>
                      <Select
                        value={this.state.selectedTypeId}
                        onChange={(event) => this.onChangeDeliveyType(event)}
                        variant='standard'>
                        {deliveryType.map((box, index) => (
                          <MenuItem key={index} value={box.id} selected sx={{height: '46px'}}>
                            {box.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <br />
            <Grid
              container
              style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                color='primary'
                onClick={() => this.moveHandler('move')}
                disabled={this.state.disableMove}
                className={classes.primaryButton}
                sx={{minWidth: '100px', minHeight:'43px'}}>
                {t("Console.MovePopup.Move")}
              </Button>
              <Button
                onClick={this.handleCloseMove}
                color='primary'
                className={classes.primaryButton}
                sx={{minWidth: '100px', minHeight:'43px'}}>
                {t("Console.MovePopup.Close")}
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );

    // Check if location type is Counter to use modern dialog
    const isCounterLocation = this.state.popupData && 
      this.state.popupData.locationtype_id === LOCATION_TYPE_ID.Counter;

    return (
      <Box component="div">
        <Box id='react-no-print' component="div">
          {isCounterLocation ? this.renderOrderDetailsDialog() : popup}
          {movePopup}
          {deletepopup}
          {this.renderCollectDeliveryDialog()}
          <ArrivedNotification />
          <Box className={classes.root} component='div'>
            {this.state.loader ? (
              <div className={classes.spinner}>
                <img
                  className={classes.spinnerImage}
                  src={spinner}
                  alt='loading'
                />
              </div>
            ) : null}
          </Box>
          <Box sx={{ p: 1, display: 'flex', ml: '4px' }}>
            <Box>
              <TextField
                label={t("Console.Search")}
                className='text-width'
                inputRef={(input) => {
                  this.searchInputRef = input;
                }}
                value={this.state.searchText}
                autoFocus
                InputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                variant="standard"
                onChange={(event) =>
                  this.inputHandler('searchText', event.target.value)
                }
                style={{ width: '35ch' }}
              />
            </Box>
            <Box sx={{ ml: '20px'}}>
              <TextField
                label={t("Console.Scan")}
                className='text-width'
                error={this.state.scanTextError}
                helperText={
                  this.state.scanTextError
                    ? 'Please Enter Valid stock code'
                    : ''
                }
                onChange={(event) =>
                  this.scanHandler('scanText', event.target.value)
                }
                InputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                variant="standard"
                style={{ width: '35ch' }}
              />
            </Box>
          </Box>
          <Grid container xs={12}>
            <Grid item className='card-pos' sm={4} xs={4} md={4} lg={4} xl={4}>
              <Card sx={{ height: 450, position: 'relative' }}>
                <Grid container sx={{ marginBottom: '-6%' }}>
                  <Grid item xs={8} sx={{mt: '10px'}}>
                    <span className='pending'>{t("Console.PendingDelivery.PendingDeliveryTitle")}</span>
                  </Grid>
                  <Grid item xs={2} sx={{mt: '-5px'}}>
                    <img src={pendingIcon} alt='Icon' className='pendingIcon'/>
                  </Grid>
                  <Grid item xs={2} className='count-position'>
                    <CardHeader sx={{pr:'30px', mt:'5px'}}
                      title={
                        this.state.pendingDelivery &&
                        this.state.pendingDelivery.total > 0
                          ? this.state.pendingDelivery.total
                          : 0
                      }
                    />
                  </Grid>
                </Grid>
                <CardContent>
                  {this.state.pendingDelivery &&
                  this.state.pendingDelivery.total === 0 ? (
                    <div>
                      <Grid container className='noDataFound'>
                        <Grid item xs={8}>
                          <span>{t("Console.NoDataFound")}</span>
                        </Grid>
                      </Grid>
                    </div>
                  ) : (
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              {t("Console.PendingDelivery.FullName")}
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              {t("Console.PendingDelivery.PUCode")}
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              {t("Console.PendingDelivery.DeliveryType")}
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              {t("Console.PendingDelivery.DestinationLocation")}
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              {t("Console.PendingDelivery.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPagePending}
                          next={() => this.fetchMoreData('pending')}
                          hasMore={this.state.hasMore}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.pendingDelivery &&
                              this.state.pendingDelivery.results
                                ? this.state.pendingDelivery.results.map(
                                    (val) => {
                                      return (
                                        <TableRow
                                          key={val.id}
                                          className='row-height'>
                                          <TableCell
                                            component='th'
                                            scope='row'
                                            align='left'
                                            className='remove-padding' sx={{ fontSize: '0.8125rem' }}>
                                            {val.first_name +
                                              ' ' +
                                              val.last_name}
                                            <br />
                                            {val.dob_str}
                                            <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                          </TableCell>
                                          {/* <TableCell
                                            component='th'
                                            scope='row'
                                            className='remove-padding'>
                                            {val.dob_str}
                                            <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                          </TableCell> */}
                                          <TableCell
                                            className='remove-padding pucode'
                                            align='left'
                                            onClick={() =>
                                              this.handleOpen('pending', val)
                                            } sx={{ fontSize: '0.8125rem' }}>
                                            {val.pucode}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='left' sx={{ fontSize: '0.8125rem' }}>
                                            {val.DeliveryType}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='left' sx={{ fontSize: '0.8125rem' }}>
                                            {val.destination_location}
                                          </TableCell>
                                          <TableCell
                                            className='remove-padding'
                                            align='center' sx={{ fontSize: '0.8125rem' }}>
                                            {val.type_id === DEVICE_TYPE.Ready
                                              ? 'Ready'
                                              : val.type_id ===
                                                DEVICE_TYPE.Out_for_Delivery
                                              ? 'Out for Delivery'
                                              : val.type_id ===
                                                DEVICE_TYPE.Arrived
                                              ? 'Arrived'
                                              : val.type_id ===
                                                DEVICE_TYPE.Stocked
                                              ? 'Stocked'
                                              : val.type_id ===
                                                DEVICE_TYPE.Return
                                              ? 'Return'
                                              : val.type_id ===
                                                DEVICE_TYPE.Cancelled
                                              ? 'Cancelled'
                                              : val.type_id ===
                                                DEVICE_TYPE.Completed
                                              ? 'Completed'
                                              : val.type_id ===
                                                DEVICE_TYPE.Assigned
                                              ? 'Assigned'
                                              : ''}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
            {this.state.counterData && this.state.counterData.total > 0 ? (
              <Grid item id="console-section-counter" className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  {this.renderConsoleLicenseCallout('counter')}
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={5} sx={{mt: '10px'}}>
                      <span className='counter'>{t("Console.Counter.CounterTitle")}</span>
                    </Grid>
                    <Grid item xs={3} sx={{mt: '7px'}}>
                      {this.renderCollectDeliveryCardButton(LOCATION_TYPE_ID.Counter)}
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={counterIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.counterData &&
                          this.state.counterData.total > 0
                            ? this.state.counterData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader'>
                              {t("Console.Counter.FullName")}
                            </TableCell>
                            <TableCell className='tableHeader'>
                              {t("Console.Counter.PUCode")}
                            </TableCell>
                            <TableCell className='tableHeader'>
                              {t("Console.Counter.CoPay")}
                            </TableCell>
                            <TableCell className='tableHeader'>
                              {t("Console.Counter.Signature")}
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                             >
                              {t("Console.Counter.StorageLocation")}
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              {t("Console.Counter.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageCounter}
                          next={() => this.fetchMoreData('counter')}
                          hasMore={this.state.hasMoreCounter}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.counterData &&
                              this.state.counterData.results
                                ? this.state.counterData.results.sort(this.compare).map((val) => {
                                    let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}
                                       >
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{ fontSize: '0.8125rem'}}>
                                          {val.first_name + ' ' + val.last_name}
                                          <br />
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell>
                                        {/* <TableCell
                                          className='remove-padding'
                                          align='right'
                                          style={{ width: '14.28%'}}>
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell> */}
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('counter', val)
                                          }
                                          style={{ fontSize: '0.8125rem'}}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell className='remove-padding' align='left' style={{ fontSize: '0.8125rem', ...val.is_paid ? { color: 'black' } : { color: 'red' }}}>
                                          {Number(val.price) > 0 ? val.is_paid ? 'Paid' : 'Due' : 'None' }
                                        </TableCell>
                                        <TableCell className='remove-padding' align='left'  style={{ fontSize: '0.8125rem'}}>
                                          {(val.signature_url !== '' && val.signature_url !== null && val.signature_url !== 'null' && val.signature_url !== undefined && val.signature_url !== 'undefined') || (val.aob_signatures_complete === true) ? 'Done' : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'  style={{ fontSize: '0.8125rem'}}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem'}}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.counterData &&
                      this.state.counterData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>{t("Console.NoDataFound")}</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.kioskData && this.state.kioskData.total > 0 ? (
              <Grid item className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={8} sx={{mt: '10px'}}>
                      <span className='kiosk'>{t("Console.Kiosk.KioskTitle")}</span>
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img src={kioskIcon} alt='Icon' className='pendingIcon' />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.kioskData && this.state.kioskData.total > 0
                            ? this.state.kioskData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              {t("Console.Kiosk.FullName")}
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              {t("Console.Kiosk.PUCode")}
                            </TableCell>
                            <TableCell
                              className='tableHeader full-name'
                            >
                              {t("Console.Kiosk.BoxName")}
                            </TableCell>
                            <TableCell className='tableHeader'>
                              {t("Console.Kiosk.StockCode")}
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              {t("Console.Kiosk.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageInKiosk}
                          next={() => this.fetchMoreData('kiosk')}
                          hasMore={this.state.hasMoreKiosk}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.kioskData &&
                              this.state.kioskData.results
                                ? this.state.kioskData.results.map((val) => {
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className='row-height'>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          >
                                          {val.first_name + ' ' + val.last_name}
                                          <br />
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell>
                                        {/* <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'>
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell> */}
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('kiosk', val)
                                          }
                                          sx={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' sx={{ fontSize: '0.8125rem' }}>
                                          {val.name}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' sx={{ fontSize: '0.8125rem' }}>
                                          {val.stock_code}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' sx={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : val.type_id ===
                                              DEVICE_TYPE.Assigned
                                            ? 'Assigned'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.kioskData &&
                      this.state.kioskData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>{t("Console.NoDataFound")}</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.curbSideData && this.state.curbSideData.total > 0 ? (
              <Grid item id="console-section-curbside" className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  {this.renderConsoleLicenseCallout('curbside')}
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={5} sx={{mt: '10px'}}>
                      <span className='curbside'>{t("Console.Curbside.CurbsideTitle")}</span>
                    </Grid>
                    <Grid item xs={3} sx={{mt: '7px'}}>
                      {this.renderCollectDeliveryCardButton(LOCATION_TYPE_ID.Curbside)}
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={curbsideIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.curbSideData &&
                          this.state.curbSideData.total > 0
                            ? this.state.curbSideData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell
                             className='tableHeader full-name'
                             >
                              {t("Console.Curbside.FullName")}
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='left'
                             >
                              {t("Console.Curbside.PUCode")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              {t("Console.Curbside.CoPay")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              {t("Console.Curbside.Signature")}
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                              >
                              {t("Console.Curbside.StorageLocation")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            >
                              {t("Console.Curbside.PatientNotes")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='center'
                            >
                              {t("Console.Curbside.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPageCurbside}
                          next={() => this.fetchMoreData('curbside')}
                          hasMore={this.state.hasMoreCurbside}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.curbSideData &&
                              this.state.curbSideData.total > 0
                                ? this.state.curbSideData.results.sort(this.compare).map((val) => {
                                  let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding' style={{ fontSize: '0.8125rem' }}>
                                          {val.first_name + ' ' + val.last_name}
                                          <br />
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell>
                                        {/* <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          style={{ width: '14.28%'}}
                                          >
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell> */}
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('curbside', val)
                                          }
                                          style={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                        className='remove-padding'
                                        align='left'
                                        style={{ fontSize: '0.8125rem', ...val.is_paid ? {color:'black'} : {color: 'red'}}}>
                                         {Number(val.price) ? val.is_paid ? 'Paid' : 'Due' : 'None' }
                                        </TableCell>
                                        <TableCell
                                        className='remove-padding'
                                        align='left'
                                        style={{ fontSize: '0.8125rem'}}>
                                          {val.signature_url !== '' && val.signature_url !== null && val.signature_url !== 'null' && val.signature_url !== undefined && val.signature_url !== 'undefined' ? 'Done' : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{fontSize: '0.8125rem'}}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }} >
                                          {val.notes &&
                                          val.notes !== null &&
                                          val.notes !== 'null' &&
                                          val.notes !== undefined &&
                                          val.notes !== 'undefined'
                                            ? val.notes
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.curbSideData &&
                      this.state.curbSideData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>{t("Console.NoDataFound")}</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.courierData && this.state.courierData.total > 0 ? (
              <Grid item id="console-section-courier" className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  {this.renderConsoleLicenseCallout('courier')}
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={5} sx={{mt: '10px'}}>
                      <span className='courier'>{t("Console.Courier.CourierTitle")}</span>
                    </Grid>
                    <Grid item xs={3} sx={{mt: '7px'}}>
                      {this.renderCollectDeliveryCardButton(LOCATION_TYPE_ID.Courier)}
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={courierIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.courierData &&
                          this.state.courierData.total > 0
                            ? this.state.courierData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell className='tableHeader full-name'>
                              {t("Console.Courier.FullName")}
                            </TableCell>
                            <TableCell className='tableHeader' align='left'>
                              {t("Console.Courier.PUCode")}
                            </TableCell>
                            <TableCell
                              className='tableHeader'
                              >
                              {t("Console.Courier.StorageLocation")}
                            </TableCell>
                            <TableCell className='tableHeader'>
                              {t("Console.Courier.PatientNotes")}
                            </TableCell>
                            <TableCell className='tableHeader' align='center'>
                              {t("Console.Courier.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowsPerPageCourier}
                          next={() => this.fetchMoreData('courier')}
                          hasMore={this.state.hasMoreCourier}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='courierbody'
                              >
                              {this.state.courierData &&
                              this.state.courierData.total > 0
                                ? this.state.courierData.results.map((val) => {
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className='row-height'>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'  style={{ fontSize: '0.8125rem' }}>
                                          {val.first_name + ' ' + val.last_name}
                                          <br />
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell>
                                        {/* <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'>
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell> */}
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          onClick={() =>
                                            this.handleOpen('courier', val)
                                          }
                                          style={{ fontSize: '0.8125rem' }}>
                                          {val.pucode}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }}>
                                          {val.storage_location !== null &&
                                          val.storage_location !== 'null' &&
                                          val.storage_location !== undefined &&
                                          val.storage_location !== 'undefined'
                                            ? val.storage_location
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left' style={{ fontSize: '0.8125rem' }}>
                                          {val.notes !== '' &&
                                          val.notes !== null &&
                                          val.notes !== 'null' &&
                                          val.notes !== undefined &&
                                          val.notes !== 'undefined'
                                            ? val.notes
                                            : ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center' style={{ fontSize: '0.8125rem' }}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.courierData &&
                      this.state.courierData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>{t("Console.NoDataFound")}</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
            {this.state.bedSideData && this.state.bedSideData.total > 0 ? (
              <Grid item id="console-section-bedside" className='card-pos' xs={4} md={4} lg={4} sm={4} xl={4}>
                <Card sx={{ height: 450, position: 'relative' }}>
                  {this.renderConsoleLicenseCallout('bedside')}
                  <Grid container sx={{ marginBottom: '-6%' }}>
                    <Grid item xs={5} sx={{mt: '10px'}}>
                      <span className='bedside'>{t("Console.Bedside.BedsideTitle")}</span>
                    </Grid>
                    <Grid item xs={3} sx={{mt: '7px'}}>
                      {this.renderCollectDeliveryCardButton(LOCATION_TYPE_ID.Bedside)}
                    </Grid>
                    <Grid item xs={2} sx={{mt: '-5px'}}>
                      <img
                        src={bedsideIcon}
                        alt='Icon'
                        className='pendingIcon'
                      />
                    </Grid>
                    <Grid item xs={2} className='count-position'>
                      <CardHeader sx={{pr: '30px', mt: '10px'}}
                        title={
                          this.state.bedSideData &&
                          this.state.bedSideData.total > 0
                            ? this.state.bedSideData.total
                            : 0
                        }
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <div style={{ overflow: 'auto' }}>
                      <Table class='fixed_headers'>
                        <TableHead className='thead'>
                          <TableRow className='row-height'>
                            <TableCell
                             className='tableHeader full-name'
                             >
                              {t("Console.Bedside.FullName")}
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='left'
                             >
                              {t("Console.Bedside.StorageLocation")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              {t("Console.Bedside.CoPay")}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              {t('Console.Bedside.Signature')}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              {t("Assign.RoomNumber", { defaultValue: "Room" })}
                            </TableCell>
                            <TableCell
                            className='tableHeader'
                            align='left'
                            >
                              {t("Console.Bedside.PatientNotes")}
                            </TableCell>
                            <TableCell
                             className='tableHeader'
                             align='center'
                             >
                              {t("Console.Bedside.Status")}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                      <div
                        scrollableTarget='scrollableDiv'
                        style={{ height: '300px', overflow: 'auto' }}>
                        <InfiniteScroll
                          dataLength={this.state.rowPerPageInPatient}
                          next={() => this.fetchMoreData('inpatient')}
                          hasMore={this.state.hasMoreInpatient}
                          height={300}
                          endMessage={
                            <p style={{ textAlign: 'center' }}>
                              <b>{t("Console.YouHaveSeenIt")}</b>
                            </p>
                          }>
                          <Table style={{ tableLayout: 'fixed' }}>
                            <TableBody
                              className='tbody'
                              >
                              {this.state.bedSideData &&
                              this.state.bedSideData.total > 0
                                ? this.state.bedSideData.results.sort(this.compare).map((val) => {
                                  let color =
                                      val.type_id &&
                                      val.type_id === DEVICE_TYPE.Arrived && val.is_paid === true
                                        ? `style-row-counter`
                                        : val.is_paid === true
                                        ? `style-row-counter-blue`
                                        : '';
                                    return (
                                      <TableRow
                                        key={val.id}
                                        className={`row-height ${color}`}>
                                        <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.first_name + ' ' + val.last_name}
                                          <br />
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell>
                                        {/* <TableCell
                                          component='th'
                                          scope='row'
                                          className='remove-padding'
                                          style={{ width: '14.28%'}}>
                                          {val.dob_str}
                                          <br/>
                                          {this.getPatientMRN(val.patient_id)}
                                        </TableCell> */}
                                        <TableCell
                                          className='remove-padding pucode'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}
                                          onClick={() =>
                                            this.handleOpen('bedside', val)
                                          }>
                                          {val.storage_location || ''}
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{  fontSize: '0.8125rem', ...val.is_paid ? {color: 'black'} : {color: 'red'}}}
                                          >
                                         {Number(val.price) ? val.is_paid ? 'Paid' : 'Due' : 'None' }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}
                                         >
                                          {val.signature_url !== '' &&
                                            val.signature_url !== null &&
                                             val.signature_url !== 'null' &&
                                              val.signature_url !== undefined &&
                                               val.signature_url !== 'undefined'
                                               ? 'Done'
                                               : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.room_number &&
                                            val.room_number !== '' &&
                                             val.room_number !== null &&
                                              val.room_number !== 'null' &&
                                               val.room_number !== undefined &&
                                                val.room_number !== 'undefined'
                                                 ? val.room_number
                                                 : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='left'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.notes &&
                                            val.notes !== null &&
                                             val.notes !== 'null' &&
                                              val.notes !== undefined &&
                                               val.notes !== 'undefined'
                                               ? val.notes
                                               : ''
                                          }
                                        </TableCell>
                                        <TableCell
                                          className='remove-padding'
                                          align='center'
                                          style={{fontSize: '0.8125rem'}}>
                                          {val.type_id === DEVICE_TYPE.Ready
                                            ? 'Ready'
                                            : val.type_id ===
                                              DEVICE_TYPE.Out_for_Delivery
                                            ? 'Out for Delivery'
                                            : val.type_id ===
                                              DEVICE_TYPE.Arrived
                                            ? 'Arrived'
                                            : val.type_id ===
                                              DEVICE_TYPE.Stocked
                                            ? 'Stocked'
                                            : val.type_id === DEVICE_TYPE.Return
                                            ? 'Return'
                                            : val.type_id ===
                                              DEVICE_TYPE.Cancelled
                                            ? 'Cancelled'
                                            : val.type_id ===
                                              DEVICE_TYPE.Completed
                                            ? 'Completed'
                                            : ''}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })
                                : ''}
                            </TableBody>
                          </Table>
                        </InfiniteScroll>
                      </div>
                      {this.state.bedSideData &&
                      this.state.bedSideData.total === 0 ? (
                        <div>
                          <Grid container className='noDataFound'>
                            <Grid item xs={8}>
                              <span>{t("Console.NoDataFound")}</span>
                            </Grid>
                          </Grid>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </Box>

        {/* Print Label Functionality  */}
        <Box component="div" id="Print_Console_Label">
          <PrintTemplate>
            <Dialog 
              open={this.state.printDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '500px' }
              }}
              >
               <DialogContent sx={{ p: '10px' }}>
                  <LabelTemplate
                    style={{ display: 'none' }}
                    stockCode={this.state.popupData.stock_code || ''}
                    pickupCode={this.state.popupData.pucode || ''}
                    signature_url={this.state.popupData.signature_url}
                    rxNumbers={
                        this.state.popupData &&
                        this.state.popupData.items &&
                        this.state.popupData.items.length > 0 &&
                        this.state.popupData.items.map(({ rx_no }) =>  rx_no)
                    }
                    boxId={this.state.popupData.box_id || ''}
                    ref={(el) => (this.componentRef = el)}
                    accountDetails={this.state.popupData.accDetails || ''}
                    pharmacyDetails={this.state.popupData.boxDetails || ''}
                    firstName={this.state.popupData.first_name || ''}
                    lastName={this.state.popupData.last_name || ''}
                    dateOfBirth={this.state.popupData.dob_str || ''}
                    isCoolItem={this.state.popupData.is_cool_item || ''}
                    prefer_location_name={this.state.popupData.box_name || ''}
                    locationTypeID={this.state.popupData.locationtype_id  || ''}
                    brandingName={(this.state.popupData.accDetails && this.state.popupData.accDetails.brand.name) || ''}
                    brandingPhone={(this.state.popupData.accDetails && this.state.popupData.accDetails.brand.phone) || ''}
                  />
                </DialogContent>
             </Dialog>
           </PrintTemplate>
          </Box>
      </Box>
    );
  }
}

export default withStyles(styles, { withTheme: true })(withTranslation()(Console));



// WEBPACK FOOTER //
// ./src/components/console/index.js